module.exports = __webpack_public_path__ + "static/media/sleep-well.c59a86bb.jpg";